module.exports = __webpack_public_path__ + "img/logo-ael.95bf86cc.png";